import { createSelector } from '@ngrx/store';
import { getOneClickState } from '@ordersnproducts/modules/one-click-order/reducers';

export const getOneClickHaulersState = createSelector(
  getOneClickState,
  state => state.haulersState,
);

export const getOneClickHaulers = createSelector(
  getOneClickHaulersState,
  state => state.haulersAvailable,
);

export const getOneClicHaulersSelected = createSelector(
  getOneClickHaulersState,
  state => state.selected,
);
